
function LoaderWhite(props) {
    return (
        <div className="dotLoader">
            <div className="lds-ellipsis lds-ellipsis-white"><div></div><div></div><div></div><div></div></div>
        </div>
    )
}
export default LoaderWhite;